import React, { useState, useEffect } from "react";
import { getgcaDocument } from "../../auth/services/privateapicalling";
import { useSelector } from "react-redux";

const SingleDocumentView: React.FC<{ docId: string | null }> = ({ docId }) => {
  const [file, setFile] = useState<{ fileData: string; mimeType: string; fileName: string, documentName: string } | null>(null);
  const [loading, setLoading] = useState(false);
  // const docId = "c6a09734-084d-495e-880d-18083c24f7b6";
  const token = useSelector((state: any) => state.auth.token);



  // Function to fetch a single document
  const loadFile = async () => {
    if(!docId) return;
    setLoading(true);
    try {
   
      const response = await getgcaDocument(docId, token, 'gca');
   

      if (response.success && response.doc) {
        setFile(response.doc);
      } else {
        setFile(null);
      }
    } catch (error) {
     
      setFile(null);
    }
    setLoading(false);
  };



  // Fetch file when the modal opens
  useEffect(() => {
    const modalElement = document.getElementById("single_doc_modal");
    loadFile();
    if (modalElement) {
      modalElement.addEventListener("shown.bs.modal", loadFile);
    }
    return () => {
      if (modalElement) {
        modalElement.removeEventListener("shown.bs.modal", loadFile);
      }
    };
  }, [docId, token]);
  
  return (
    <div className="modal fade" id="single_doc_modal" tabIndex={-1} aria-hidden="true">
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">View Document</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body" style={{ maxHeight: "500px", overflowY: "auto" }}>
            {loading && <p>Loading...</p>}
            {!loading && !file && <p>No document found</p>}
            {file &&
              (

                <div className="mt-3">
                  <p><strong>{file.fileName} </strong></p>
                  {/* Image File */}
                  {file.mimeType.startsWith("image/") && (
                    <img src={file.fileData} alt={file.fileName} style={{ width: "100%", maxHeight: "700px" }} />
                  )}
                  {/* PDF File */}
                  {file.mimeType === "application/pdf" && (
                    <iframe src={file.fileData} width="100%" height="500px" title="PDF Viewer" />
                  )}
                  {/* Other File Types */}
                  {!file.mimeType.startsWith("image/") && file.mimeType !== "application/pdf" && (
                    <a href={file.fileData} download={file.fileName} className="text-primary">
                      Download {file.fileName}
                    </a>
                  )}
                </div>
              )}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleDocumentView;
